import React from 'react';
import PillarPageTemplate from '../../components/PillarPageTemplate';
import { bsrAmData } from '../../data/pillars/bsrAm';

export default function PillarBsrAm() {
  return <PillarPageTemplate data={bsrAmData} />;
}
